export const STORE_HASHES = 'STORE_HASHES'

export const STORE_TRANSACTION_BONDS =  'STORE_TRANSACTION_BONDS'